// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2qCLf","colMin":"styles_colMin__3ahgr","colCheckbox":"styles_colCheckbox__1H6ke"};